import { useState } from "react";
import cancelImage from "../assets/images/cancel.png";
import {
  useCompleteSingleTodoMutation,
  useDeleteTodoMutation,
  useUpdateColorMutation,
  useUpdateTitleMutation
} from "../redux/features/api/apiSlice";

export default function Todo({ todo }) {
  const { text, id, completed, color } = todo;

  const [updateStatus] = useCompleteSingleTodoMutation();
  const [updateColor] = useUpdateColorMutation();
  const [deleteTodo] = useDeleteTodoMutation();
  const [updateTitle] = useUpdateTitleMutation();
  const [isEdit, setIsEdit] = useState(false);
  const [input, setInput] = useState("");

  const handleInput = (e) => {
    setInput(e.target.value);
  };

  const handleStatusChange = (id) => {
    updateStatus({ id, data: todo });
  };

  const handleColorChange = (id, color) => {
    updateColor({ id, data: todo, color });
  };

  const handleDelete = (todoId) => {
    deleteTodo(todoId);
  };

  const handleTitleChange = (id) => {
    updateTitle({ id, data: todo, title: input });
  };

  return (
    <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
      <div
        className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
          completed && "border-green-500 focus-within:border-green-500"
        }`}
      >
        <input
          type="checkbox"
          checked={completed}
          onChange={() => handleStatusChange(id)}
          className="opacity-0 absolute rounded-full"
        />
        {completed && (
          <svg
            className="fill-current w-3 h-3 text-green-500 pointer-events-none"
            viewBox="0 0 20 20"
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        )}
      </div>
      {!isEdit && (
        <div className={`select-none flex-1 ${completed && "line-through"}`}>
          {text}
        </div>
      )}
      {isEdit && (
        <div className={`select-none flex-1`}>
          <input
            type="text"
            placeholder={text}
            className="w-full border-none outline-none bg-gray-100 text-gray-500"
            value={input}
            onChange={handleInput}
          />
        </div>
      )}
      {!completed && (
        <div
          className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer`}
          onClick={() => {
            setIsEdit(!isEdit);
            isEdit && !!input.length && handleTitleChange(id);
          }}
        >
          {!isEdit && (
            <img
              src="https://img.icons8.com/ios-glyphs/344/edit--v1.png"
              alt=""
            />
          )}
          {isEdit && (
            <img
              src="https://img.icons8.com/ios-glyphs/344/save--v1.png"
              alt=""
            />
          )}
        </div>
      )}
      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
          color === "green" && "bg-green-500"
        }`}
        onClick={() => handleColorChange(id, "green")}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
          color === "yellow" && "bg-yellow-500"
        }`}
        onClick={() => handleColorChange(id, "yellow")}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
          color === "red" && "bg-red-500"
        }`}
        onClick={() => handleColorChange(id, "red")}
      ></div>
      {!completed && (
        <img
          src={cancelImage}
          className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
          alt="Cancel"
          onClick={() => handleDelete(id)}
        />
      )}
    </div>
  );
}
